// Wires the universal hamburger menu rendered by app/views/shared/_site_menu.html.erb.
// Right-anchored slide-in drawer with a dimmed backdrop. Toggles `data-open`
// on the drawer + backdrop (Tailwind variants drive the transform/opacity
// transition), locks body scroll while open, closes on Escape or backdrop
// click, and keeps Tab focus inside the panel.
export function setupHamburger() {
  const panel = document.querySelector("[data-hamburger-panel]")
  if (!panel) return

  const drawer = panel.querySelector("[data-hamburger-drawer]")
  const backdrop = panel.querySelector("[data-hamburger-backdrop]")
  const openers = document.querySelectorAll("[data-hamburger-toggle]")
  const closers = panel.querySelectorAll("[data-hamburger-close]")
  const TRANSITION_MS = 300
  let lastFocused = null

  const focusable = () =>
    Array.from(
      drawer.querySelectorAll(
        'a[href], button:not([disabled]), input:not([disabled]), [tabindex]:not([tabindex="-1"])'
      )
    ).filter((el) => el.offsetParent !== null)

  function onKeydown(e) {
    if (e.key === "Escape") {
      close()
      return
    }
    if (e.key !== "Tab") return
    const items = focusable()
    if (items.length === 0) return
    const first = items[0]
    const last = items[items.length - 1]
    if (e.shiftKey && document.activeElement === first) {
      e.preventDefault()
      last.focus()
    } else if (!e.shiftKey && document.activeElement === last) {
      e.preventDefault()
      first.focus()
    }
  }

  function open() {
    lastFocused = document.activeElement
    panel.hidden = false
    document.body.style.overflow = "hidden"
    // Next frame so the transition runs from the initial off-screen state.
    requestAnimationFrame(() => {
      drawer.dataset.open = "true"
      backdrop.dataset.open = "true"
    })
    openers.forEach((b) => b.setAttribute("aria-expanded", "true"))
    const items = focusable()
    if (items.length) items[0].focus()
    document.addEventListener("keydown", onKeydown)
  }

  function close() {
    delete drawer.dataset.open
    delete backdrop.dataset.open
    openers.forEach((b) => b.setAttribute("aria-expanded", "false"))
    document.removeEventListener("keydown", onKeydown)
    // Wait for the slide-out before hiding so the transition is visible.
    window.setTimeout(() => {
      panel.hidden = true
      document.body.style.overflow = ""
      if (lastFocused && typeof lastFocused.focus === "function") lastFocused.focus()
    }, TRANSITION_MS)
  }

  openers.forEach((b) => b.addEventListener("click", open))
  closers.forEach((b) => b.addEventListener("click", close))
  backdrop.addEventListener("click", close)
}
